<script setup lang="ts">
import { ref, watch } from 'vue';
import TrademarkType from './components/trademark-type.vue';
import TrademarkImage from './components/trademark-image.vue';
import TrademarkWord from './components/trademark-word.vue';
import {useTrademarkStore} from '@/store/mark';
import {MarkType} from '@/core/interface/api-interface';
import ApplicationStepHeader from '@/components/common/application-step-header.vue';
import StfBulletPoint from '@/ui/list/StfBulletPoint.vue';
import {storeToRefs} from 'pinia';
import {useApplicationStore} from '@/store/application';

const trademarkStore = useTrademarkStore();
const {uploadedAsWordImage} = storeToRefs(trademarkStore);
const { hasValidation } = storeToRefs(useApplicationStore());

const markType = ref<MarkType | null>(trademarkStore.trademarkType);

watch(markType, (newValue) => {
    if (newValue === MarkType.WORDS_IMAGE) {
        uploadedAsWordImage.value = true;
    }
})

</script>

<template>
    <StfCard :success="trademarkStore.isTrademarkStepValid" :error="hasValidation && !trademarkStore.isTrademarkStepValid">
        <template #title>
            <ApplicationStepHeader title="Add Trademark" :help="true" help-title="Add Trademark">
                <template #help>
                    <div class="mb-2">A trademark for your brand name provides the broadest form of protection, as it covers the words used in any format - regardless of the font, colour, style or size.</div>
                    <div class="mb-2">A logo trademark provides protection of the visual elements of the logo, as well as a degree of protection for any words incorporated in the logo.</div>
                    <div class="mb-2"><b>Tips:</b></div>
                    <StfBulletPoint padding-left="30px">
                        <li>Logos tend to have a better chance of being automatically approved by the Trademark Office, as they offer additional distinctive elements.</li>
                    </StfBulletPoint>
                </template>
            </ApplicationStepHeader>
        </template>
        <template #content>
            <StfSubHeading>Select the type of trademark to protect:</StfSubHeading>
            <TrademarkType v-model="markType"/>
            <StfDivider v-if="markType != null"></StfDivider>
            <TrademarkImage v-if="markType == MarkType.IMAGE || markType == MarkType.WORDS_IMAGE"/>
            <TrademarkWord v-if="markType == MarkType.WORDS"/>
        </template>
    </StfCard>
</template>

<style scoped>

</style>
